import MoreLikeThisPage from './MoreLikeThisPage';
import MoreLikeThisPageContainer from './MoreLikeThisPage.container';

export default MoreLikeThisPageContainer(MoreLikeThisPage);
